<template>
    <div>
        <div class="appwrap bg">
            <div class="setting-box">
                <div class="left">
                    <ul>
                    	<div class="isactive"></div>
                        <router-link v-for="(item, index) in list " :key="index" active-class="active" :to="{name: item.path}" tag="li" >{{item.name}}</router-link>
                    </ul>
                </div>
                <div class="right">
                    <keep-alive>    
                        <router-view></router-view>
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name:'PersonalSettrt',
    data() {
        return {
            list: [
                {
                    name: '个人设置',
                    active: true,
                    path: 'accountSet'
                },
                {
                    name:'我的账户',
                    active:false,
                    path:'mybill'
                },
                {
                    name:'付费专栏',
                    active:false,
                    path:'payList'
                }
            ]
        }
    },
    methods: {
        
    }
}
</script>

<style lang="stylus" scoped>
.bg
    background #fff
    padding 60px 0
    .setting-box
        min-height 900px
        display flex
        .left   
            width 187px
            border-right 1px solid #eee
            ul
                li
                    line-height 30px
                    margin:30px 67px 30px 0;
                    text-align center
                    font-size 22px
                    width 120px
                    color:rgba(7,19,54,0.6);
                    cursor pointer
                    border-left 4px solid rgba(255,255,255,1)
                    &:hover 
                        // background #f0f6fe
                .active
                    border-left 4px solid rgba(255,181,0,1)
                    color:rgba(7,19,54,1);
        .right
            padding 45px 55px
            flex 1
</style>



// WEBPACK FOOTER //
// src/components/personalSetter/index.vue